const AccordionFaq = () => {
  let question = document.querySelectorAll(".question");
  if (question) {
    question.forEach((question) => {
      question.addEventListener("click", (event) => {
        const active = document.querySelector(".question.active");
        if (active && active !== question) {
          active.classList.toggle("active");
          active.nextElementSibling.style.maxHeight = 0;
        }
        question.classList.toggle("active");
        const answer = question.nextElementSibling;
        if (question.classList.contains("active")) {
          answer.style.maxHeight = answer.scrollHeight + 20 + "px";
        } else {
          answer.style.maxHeight = 0;
        }
      });
    });
  }
};
export { AccordionFaq };
